import { useAuthContext } from '@asgardeo/auth-react';
import React, { useState, useEffect, useRef } from 'react';

function SigninButton() {
  const [isLoading, setIsLoading] = useState(false);
  const { signIn, state } = useAuthContext();
  const clickTimeoutRef = useRef(null);
  const isProcessingRef = useRef(false);
  window.dataLayer = window.dataLayer || [];

  // Reset loading when user becomes authenticated
  useEffect(() => {
    if (state.isAuthenticated) {
      setIsLoading(false);
      isProcessingRef.current = false;
    }
  }, [state.isAuthenticated]);

  // Cleanup timeout when component unmounts
  useEffect(() => {
    return () => {
      if (clickTimeoutRef.current) {
        clearTimeout(clickTimeoutRef.current);
      }
    };
  }, []);

  const handleClick = async () => {
    if (isLoading || isProcessingRef.current) return;

    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }

    setIsLoading(true);
    isProcessingRef.current = true;

    try {
      // Store redirect info
      const urlString = window.location.search;
      if (urlString) {
        sessionStorage.setItem('urlString', urlString);
      }
      sessionStorage.setItem('redirectAfterLogin', window.location.pathname);

      // Prevent rapid clicks
      await new Promise(resolve => {
        clickTimeoutRef.current = setTimeout(resolve, 200);
      });

      // Start sign in
      await signIn();

      // Log event
      window.dataLayer.push({
        event: 'login',
        event_category: 'User',
        event_label: 'Successful Login',
      });
    } catch (error) {
      console.error('Sign in error:', error);
    } finally {
      // Always reset states
      setIsLoading(false);
      isProcessingRef.current = false;
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 whitespace-nowrap">
      <button
        onClick={handleClick}
        disabled={isLoading || isProcessingRef.current}
        className={`
          ${isLoading || isProcessingRef.current
            ? 'bg-gray-400 cursor-not-allowed'
            : 'text-white bg-gradient-to-br from-[#dd0c7e] via-[#ca1582] to-[#a6208e] hover:from-[#a6208e] hover:via-[#ca1582] hover:to-[#dd0c7e] transition duration-500 ease-in-out'
          }
          rounded-[25px] text-sm px-[15px] h-[30px]
        `}
      >
        Sign in
      </button>
    </div>
  );
}

export default SigninButton;
